<template>
    <div class="enterprise home_bg">
        <Header :title="title" :is_company="is_company" :is_top="info.display_image"></Header>
        <div style="width: 100%;height: 80px;"></div>
        <div class="main">
            <div class="main_fl fl">
                <div class="wx_box">
                    <div class="wx_main">
                        <div class="top">
                            <div class="wx_title fl">
                                <span>公司简介</span>
                            </div>
                        </div>
                        <div class="content">
                            <p>{{info.introduce}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main_fr fr">
                <div class="wx_box">
                    <div class="wx_main">
                        <div class="top">
                            <div class="wx_title fl">
                                <span>公司信息</span>
                            </div>
                        </div>
                        <div class="content">
                            <p>公司法人: {{info.law_person}}</p>
                            <p>注册资金: {{info.reg_money}}万元人民币</p>
                            <p>成立时间: {{info.reg_day}}</p>
                            <p>现有职工: {{info.people_count}}人</p>
                            <p>拥有园区: {{info.farm_count}}个</p>
                            <p>种植面积: {{info.total_area}}亩</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="park fl">
                <div class="wx_box">
                    <div class="wx_main">
                        <div class="top">
                            <div class="wx_title fl">
                                <span>公司园区</span>
                            </div>
                        </div>
                        <ul class="list">
                            <li v-for="(item,index) in farm_list" :key="index"  @click="jump(item.id)" style="cursor: pointer;">
                                <div class="list_pic">
                                    <img :src="item.cover_image" alt="" style="width: 430px;height: 251px;">
                                </div>
                                <div class="msg">
                                    <h3>{{item.name}}</h3>
                                    <p>{{item.intro}}</p>
                                    <div class="foot">
                                        <div class="label">管理团队:</div>
                                        <div class="pics">
                                            <img :src="user.user.avatar" alt="" v-for="(user,inx) in item.user">
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="lastLi">
                                <el-button @click="addPark">建立园区</el-button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import {get_user_company} from '@/api/api'
	
    import Header from '@/components/Header';
    export default {
        name: "enterprise",
        data(){
            return{
                title:'',
			    info:{},
				farm_list:[],
				is_company:true,
				
            }
        },
		created() {
			this.get_user_company()
		},
        methods:{
			jump(id){
				console.log(1111)
				this.$router.push('/park/detail/'+ id)
			},
			// 建立园区
			addPark() {
				this.$router.push('/bulid');
			},
            get_user_company(){
				get_user_company().then(resp=>{
					 this.farm_list=resp.farm_list
					 this.info=resp.info
					 this.title=resp.info.truename
					 
					
				})
			}
        },
        components: {
            Header
        }
    }
</script>

<style scoped lang="less">
    .enterprise{
        .main{
            padding: 0 30px;
            .main_fl{
                width: 65%;
            }
            .main_fr{
                width: 32%;
            }
            .wx_box{
                .wx_main{
                    min-height: 290px;
                    padding: 13px 24px 41px 17px;
                    background:radial-gradient(rgba(19, 62, 173, 0.74),rgba(5, 18, 32, 0.47));
                    background-size: cover;
                    .top{
                        width: 100%;
                        padding-bottom: 14px;
                        overflow: hidden;
                    }
                    .content{
                        p{
                            font-size: 15px;
                            color: #C9CED8;
                            line-height: 28px;
                        }
                    }
                }
            }
            .park{
                width: 100%;
                .wx_box{
                    .wx_main{
                        padding: 13px 0 41px 0;
                        .top{
                            padding: 0 21px 0 17px;
                        }
                    }
                }
                .list{
                    margin-top: 12px;
                    display: flex;
                    flex-wrap: wrap;
                    li{
                        width: 430px;
						min-height: 460px;
                        background: #031A46;
                        margin-bottom: 32px;
                        margin-left: 17px;
                        .list_pic{
                            width: 430px;
                            height: 251px;
                            img{
                                width: 100%;
                            }
                        }
                        .msg{
                            padding: 20px 19px 30px 19px;
                            h3{
                                font-size: 20px;
                                font-weight: 800;
                                color: #5FBBBC;
                                line-height: 28px;
                                padding: 25px 0 8px 0;
                            }
                            p{
                                width: 360px;
                                font-size: 18px;
                                font-weight: 500;
                                color: #CBDADA;
                                line-height: 25px;
                                overflow:hidden;
                                text-overflow:ellipsis;
                                display:-webkit-box;
                                -webkit-box-orient:vertical;
                                -webkit-line-clamp:2;
                                margin-bottom: 12px;
                            }
                            .foot{
                                display: flex;
                                align-items: center;
                                .label{
                                    font-size: 18px;
                                    color: #CBDADA;
                                }
                                .pics{
                                    padding-left: 13px;
                                    img{
                                        width: 30px;
                                        height: 30px;
                                        border-radius: 50%;
                                        &+img{
                                            margin-left: -10px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .lastLi{
                        display: flex;
                        justify-content: space-around;
                        align-items: center;
                        .el-button{
                            width: 180px;
                            height: 50px;
                            line-height: 50px;
                            background: #2D99FF;
                            border: 1px solid #979797;
                            font-size: 18px;
                            color: #fff;
                            border-radius: 0;
                            padding: 0;
                        }
                    }
                }
            }
        }
    }
</style>
